import React, {createContext, ReactNode, useContext, useEffect, useRef, useState} from 'react';


const backoff = { base: 1000, max: 10000, current: 0 };

export const WebsocketContext = createContext<any>({});

export const WebsocketProvider: React.FC = ({children}: any) => {
    const [ws, setWs] = useState<WebSocket | null>(null);
    const [connected, setConnected] = useState<boolean>(false)
    const heartbeat = useRef<any>(null)
    const reconnectTimer = useRef<any>(null)

    function connect(wsURL: string) {
        const newWS = new WebSocket(wsURL);
        setWs(newWS)
        // Option A: pass token via query (if server supports it)
        newWS.onopen = () => {
            console.log('[ws] connected');
            backoff.current = 0;
            // Option B: send auth message after open (if server expects it)
            // ws.send(JSON.stringify({ action: 'auth', session_token: SESSION_TOKEN }));

            // (optional) subscribe to a specific event type, if required by server
            // ws.send(JSON.stringify({ action: 'subscribe', event_type: 'signature_status' }));

            // Heartbeat ping every 30s (if server expects pings)

            setConnected(true)
            heartbeat.current = setInterval(() => {
                if (newWS.readyState === WebSocket.OPEN) {
                    newWS.send(JSON.stringify({ type: 'ping', ts: Date.now() }));
                }
            }, 30000);
        };

        newWS.onerror = (err) => {
            console.log('test error')

            console.error('[ws] error', err);
            setConnected(false)
        };

        newWS.onclose = () => {
            console.log('test onClose')
            console.warn('[ws] closed');
            clearInterval(heartbeat.current);
            setConnected(false)
            // Exponential backoff reconnect
            backoff.current = Math.min(backoff.max, backoff.current ? backoff.current * 2 : backoff.base);
            reconnectTimer.current = setTimeout(connect, backoff.current);
        };

    }


    return (
        <WebsocketContext.Provider value={{ws, connect, connected}}>
            {children}
        </WebsocketContext.Provider>
    );
};


export const useWebsocket = () => {
    const context = useContext(WebsocketContext);
    if (context === undefined) {
        throw new Error('useWebsocket must be used within a WebsocketProvider');
    }
    return context;
};
